/* eslint-disable camelcase */
import { createReducer } from '@reduxjs/toolkit';
import { SignUpActions } from './actions';
import { SIGN_UP_STAGES } from '../../../Constants/Common';
import Constants, { codeMap } from './constants';
import { getKeyByValue } from './utils';

const initialState = {
  signUpTerms: false,
  fields: {
    firstName: null,
    lastName: null,
    email: null,
    phone: null,
    company: null,
    job: null,
    teamSize: null,
    industry: null,
    otherIndustryDescription: null,
    useCaseCode: null,
    subUseCaseCode: null,
    useCaseText: null,
    otherDescription: null,
    captcha: null,
    agreeToTerms: null,
  },
  moreInfo: null,
  isLoading: false,
  prepopulatedFields: {
    firstName: window.__INITIAL_STATE?.token?.firstName || '',
    lastName: window.__INITIAL_STATE?.token?.lastName || '',
    email: window.__INITIAL_STATE?.token?.email || '',
    company: window.__INITIAL_STATE?.token?.company || '',
    phone: window.__INITIAL_STATE?.token?.phone || '',
    product: window.__INITIAL_STATE?.token?.product || '',
    isPurchaseLink: window.__INITIAL_STATE?.token?.isPurchaseLink || false,
    useCaseCode: window.__INITIAL_STATE?.token?.useCaseCode || '',
    subUseCaseCode: window.__INITIAL_STATE?.token?.subUseCaseCode || '',
    useCaseText: window.__INITIAL_STATE?.token?.subUseCaseCode
      ? getKeyByValue(codeMap, window.__INITIAL_STATE?.token?.subUseCaseCode)
      : window.__INITIAL_STATE?.token?.useCaseCode
      ? getKeyByValue(codeMap, window.__INITIAL_STATE?.token?.useCaseCode)
      : '',
    otherDescription: window.__INITIAL_STATE?.token?.otherDescription || '',
    contactEmails: window.__INITIAL_STATE?.token?.contactEmails || [],
  },
};

const ACTION_HANDLER = {
  [SignUpActions.submitSignUp]: (state) => {
    state.isLoading = true;
  },
  [SignUpActions.submitSignUpSucceeded]: (state) => {
    state.isLoading = false;
    state.moreInfo = false;
  },
  [SignUpActions.submitSignUpFailed]: (state) => {
    state.isLoading = false;
  },
  [SignUpActions.updateFields]: (state, action) => {
    const newField = action.payload;
    const key = Object.keys(newField)[0];
    const value = Object.values(newField)[0];
    state.fields = {
      ...state.fields,
      [key]: value,
    };
  },
};

export const signUpReducer = createReducer(initialState, ACTION_HANDLER);

export default {
  name: Constants.MODULE_NAME,
  reducer: signUpReducer,
};
